import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="w-full bg-background-50 pb-4">
      <div className="w-full px-4 md:px-6">
        <div className="rounded-lg bg-accent-500 px-6 md:px-10 py-10 md:py-12 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
              有靠谱的话题线索？欢迎交给我们整理
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-800 max-w-2xl leading-relaxed">
              我们优先处理可公开查证、且属于行业现象或公开活动的内容。来信请说明话题所属分类与背景，编辑团队会逐一阅读。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <Link
              to="/about#contact"
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-edit-2-line"></i>
              提交话题线索
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md border border-foreground-900/30 text-foreground-950 text-sm font-medium hover:border-foreground-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解内容原则
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}